// extracted by mini-css-extract-plugin
export default {"hide":"DataContent_hide__OdMOi","button_wrapper":"DataContent_button_wrapper__TklLd"};